import { BOOK_PAGE_BREAK, PAGE_LOAD } from './jigsaw-events';
import { HAS_NEXT_PAGE, HAS_PREV_PAGE } from './jigsaw-methods';
import { isEmpty } from 'app/utils/objects';

export function getCurrentCfi(state) {
  const loads = getPageLoadsWithData(state);
  if (loads.length > 0) {
    return loads[0].cfi;
  }
  return null;
}

export function getCurrentPage(state) {
  return state.jigsaw[BOOK_PAGE_BREAK].value;
}

export function hasNextPage(state) {
  return state.jigsaw[HAS_NEXT_PAGE].data;
}

export function hasPrevPage(state) {
  return state.jigsaw[HAS_PREV_PAGE].data;
}

export function isPageLoading(state) {
  return state.jigsaw.pageLoading;
}

function getPageLoadsWithData(state) {
  return state.jigsaw[PAGE_LOAD].filter(evt => evt && !isEmpty(evt));
}

export function getPageAspectRatio(state) {
  const sizes = getPageLoadsWithData(state).map(cv => {
    if (cv.docViewportHeight) {
      return { w: cv.docViewportWidth, h: cv.docViewportHeight };
    } else {
      return { w: cv.boundingRectWidth, h: cv.boundingRectHeight };
    }
  });

  const isValid = sizes.reduce((acc, cv) => {
    return acc && !!cv.w && !!cv.h;
  }, true);

  if (isValid) {
    return sizes.reduce((acc, cv) => {
      return acc + cv.w / cv.h;
    }, 0);
  }

  return null;
}

export function getDocViewportWidth(state) {
  const data = getPageLoadsWithData(state);
  if (data.length > 0) {
    if (data[0].docViewportWidth) {
      return data.reduce((acc, cv) => {
        return acc + cv.docViewportWidth;
      }, 0);
    }
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/page-context-selectors.js